/**
 * Cámara con seguimiento por lerp (TKT-014).
 *
 * El cliente PC no decide nada autoritativo (ADR-0002), pero la cámara sí es
 * estado puro de presentación. Se aplica al `Phaser.Cameras.Scene2D.Camera`
 * externamente; aquí mantenemos la lógica pura de blend para test.
 */

export interface CameraTarget {
  x: number;
  y: number;
}

export function lerpCameraStep(
  current: CameraTarget,
  target: CameraTarget,
  factor: number,
): CameraTarget {
  const f = Math.max(0, Math.min(1, factor));
  return {
    x: current.x + (target.x - current.x) * f,
    y: current.y + (target.y - current.y) * f,
  };
}
